/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

// Custom styles
import "./scss/main.scss";

// Custom images
const requireContext = require.context("./images", true, /\.(png|svg|jpg|jpeg|gif)$/i);

requireContext.keys().map(requireContext);

// Custom scripts
import { Iksoris } from "./js/Iksoris";
import { Modal } from "./js/components/Modal";
import { Preloader } from "./js/components/Preloader";
import { DropdownMenu } from "./js/components/DropdownMenu";
import { MainSidebar } from "./js/layout/MainSidebar";
import { Tabs } from "./js/components/Tabs";
import { AjaxListener } from "./js/core/AjaxListener";
import { TypeColor } from "./js/components/form/TypeColor";

// Tworzenie obiektu (przestrzeni nazw) iksoris.
const iksoris = new Iksoris();

window.iksoris = iksoris;

/**
 * Preloader
 * @type {Preloader}
 */
const preloader = new Preloader("body", true);

// Wczytanie po załadowaniu drzewa DOM
window.addEventListener("DOMContentLoaded", (event) => {
    /**
     * Włączenie podpowiedzi (tooltip bootstrap).
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    /**
     * Modal
     * @type {Modal}
     */
    iksoris.Modal = new Modal("modal", [].slice.call(document.querySelectorAll('[data-toggle="modal"]')));

    /**
     * DropdownMenu
     * @type {DropdownMenu}
     */
    const navbar = new DropdownMenu();

    /**
     * MainSidebar
     * @type {MainSidebar}
     */
    if (Boolean(document.getElementById("main-sidebar"))) {
        const mainSidebar = new MainSidebar(document.getElementById("main-sidebar"));
    }

    /**
     * Multiple
     */
    iksoris.createMultiple();

    /**
     * Autocomplete
     */
    iksoris.createAutocomplete();

    /**
     * Dialog
     */
    iksoris.createDialog();

    /**
     * Projects Calendar
     */
    iksoris.createProjectsCalendar();

    /**
     * Drag and drop
     */
    iksoris.createDragAndDrop();

    /**
     * Drag and drop files
     */
    iksoris.createDragAndDropFiles();

    /**
     * TableCaption
     */
    iksoris.createTableCaption();

    /**
     * Switch
     */
    iksoris.createSwitch();

    /**
     * Tabs
     */
    const tabsList = [].slice.call(document.querySelectorAll('[data-toggle="tabs"]'));

    if (tabsList.length > 0) {
        const tabs = tabsList.map(function (element) {
            return new Tabs(element);
        });
    }

    /**
     * Ajax listener
     * @type {AjaxListener}
     */
    const ajaxListener = new AjaxListener();

    // Ustawienie ponownej reinicjalizacji modułów Multiple, Autocomplete, Dialog po zakończeniu jakiegokolwiek żądania Ajax.
    ajaxListener.ajaxStopFunction = function () {
        iksoris.reloadInstances();
    };

    //
    ajaxListener.ajaxEvents();
});

/**
 * Input type color
 * @type {TypeColor}
 */
const typeColor = new TypeColor();
